/* eslint-disable react/display-name */
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from "@material-ui/core";
import { forwardRef } from "react";
import { TableVirtuoso } from "react-virtuoso";

const TableComponents = {
  Scroller: forwardRef((props, ref) => (
    <TableContainer component={Paper} {...props} ref={ref} />
  )),
  Table: props => <Table {...props} style={{ borderCollapse: "separate" }} />,
  TableHead: TableHead,
  TableRow: TableRow,
  TableBody: forwardRef((props, ref) => <TableBody {...props} ref={ref} />)
};

export const BatchTable = ({ batchData }) => {
  const TableHeader = () => (
    <TableHead>
      <TableRow>
        <TableCell>ID</TableCell>
        <TableCell>Produto</TableCell>
        <TableCell>Criado em:</TableCell>
        <TableCell>Recebido em:</TableCell>
        <TableCell>Status</TableCell>
        <TableCell>Estágio</TableCell>
      </TableRow>
    </TableHead>
  );

  return (
    <TableVirtuoso
      style={{ height: 400 }}
      data={batchData}
      components={{
        ...TableComponents,
        TableHead: TableHeader
      }}
      fixedHeaderContent={() => {}}
      itemContent={(_, batch) => (
        <>
          <TableCell>{batch?.id}</TableCell>
          <TableCell>{batch.productName}</TableCell>
          <TableCell>{batch.createdDate}</TableCell>
          <TableCell>{batch.receiptDate}</TableCell>
          <TableCell>{batch.status}</TableCell>
          <TableCell>{batch.stage}</TableCell>
        </>
      )}
    />
  );
};
